import type { LocationPing, RouteTrack } from '@fdt/shared';
import { api } from '../api/client';

/**
 * Reading recorded positions.
 *
 * Its own client rather than a field on the route resource, because every call
 * here is logged server-side as an access to someone's location data
 * (DECISIONS D97) — a request that gets logged should look like a request in
 * the code too, not like reading a property.
 */
export const trackingApi = {
  async routeTrack(routeId: string): Promise<RouteTrack> {
    const { data } = await api.get<RouteTrack>(`/routes/${routeId}/track`);
    return data;
  },

  async live(): Promise<LocationPing[]> {
    const { data } = await api.get<LocationPing[]>('/tracking/live');
    return data;
  },

  async enforceRetention(): Promise<{ deleted: number; cutoff: string }> {
    const { data } = await api.post<{ deleted: number; cutoff: string }>('/tracking/retention');
    return data;
  },
};
